import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AnalyticsActions from 'app/actions/AnalyticsActions';
import { ANALYTICS_CONTEXTS } from 'app/constants/AnalyticsConstants';
import { bibContextShape } from 'app/shapes/analytics';
import AnalyticsContext from './AnalyticsContext';

export class AnalyticsContextContainer extends React.PureComponent {
  render() {
    return <AnalyticsContext {...this.props} />;
  }
}

AnalyticsContextContainer.propTypes = {
  analyticsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  context: bibContextShape.isRequired,
  contextName: PropTypes.oneOf([ANALYTICS_CONTEXTS.BIB]).isRequired
};

const mapDispatchToProps = dispatch => ({
  analyticsActions: bindActionCreators(AnalyticsActions, dispatch)
});

export default connect(null, mapDispatchToProps)(AnalyticsContextContainer);
